export default {
  "menu.LicenseListPage": "场所证件",
}